export const environment = {
  production: true,
  apiUrl: 'https://devlevelsapi.minatrades.com/api'
};
